import React from 'react';
import Illustration, { IllustrationProps } from './Illustration';

//
const NotFoundSvg: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg
            width="1004"
            height="1000"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
            viewBox="0 0 1004 1000"
        >
            <path
                d="M306.549 465.277C348.979 465.202 383.436 499.537 383.512 541.967L229.86 542.24C229.784 499.81 264.119 465.353 306.549 465.277Z"
                fill="#E9ECEF"
            />
            <path
                d="M146.497 498.589C170.687 498.546 190.332 518.121 190.375 542.312L102.774 542.467C102.731 518.277 122.306 498.632 146.497 498.589Z"
                fill="#E9ECEF"
            />
            <path
                d="M229.711 461.904C274.08 461.825 310.112 497.73 310.191 542.099L149.515 542.385C149.436 498.015 185.341 461.983 229.711 461.904Z"
                fill="#E9ECEF"
            />
            <path
                d="M397.625 541.944L81.8197 542.506"
                stroke="#000216"
                strokeWidth="3"
                strokeLinecap="square"
                strokeLinejoin="round"
            />
            <path
                d="M667.216 351.89C624.787 351.814 590.329 386.149 590.254 428.579L743.906 428.852C743.981 386.423 709.646 351.965 667.216 351.89Z"
                fill="currentColor"
            />
            <path
                d="M827.269 385.201C803.079 385.158 783.434 404.734 783.391 428.924L870.992 429.08C871.035 404.889 851.46 385.244 827.269 385.201Z"
                fill="currentColor"
            />
            <path
                d="M744.055 348.516C699.686 348.437 663.653 384.342 663.574 428.711L824.25 428.997C824.329 384.628 788.425 348.595 744.055 348.516Z"
                fill="currentColor"
            />
            <path
                d="M576.141 428.557L891.946 429.118"
                stroke="#000216"
                strokeWidth="3"
                strokeLinecap="square"
                strokeLinejoin="round"
            />
            <path
                d="M875.775 707.807L836.012 742.346L729.976 606.718L682.26 646.663L430.425 315.43L207.75 707.807L146.779 640.414L35.4414 823.274H968.556L875.775 707.807Z"
                fill="#CED4DA"
            />
            <path
                d="M2 823.275H1002"
                stroke="#000216"
                strokeWidth="3"
                strokeLinecap="square"
                strokeLinejoin="round"
            />
            <path
                d="M464.987 179.374C507.416 179.298 541.874 213.633 541.949 256.063L388.297 256.336C388.222 213.906 422.557 179.449 464.987 179.374Z"
                fill="#E9ECEF"
            />
            <path
                d="M304.934 212.685C329.124 212.642 348.769 232.217 348.812 256.408L261.211 256.564C261.168 232.373 280.744 212.728 304.934 212.685Z"
                fill="#E9ECEF"
            />
            <path
                d="M388.148 176C432.517 175.921 468.55 211.826 468.629 256.195L307.953 256.481C307.874 212.112 343.778 176.079 388.148 176Z"
                fill="#E9ECEF"
            />
            <path
                d="M556.062 256.04L240.257 256.602"
                stroke="#000216"
                strokeWidth="3"
                strokeLinecap="square"
                strokeLinejoin="round"
            />
        </svg>
    );
};
const NotFound: React.FC<IllustrationProps> = (props) => (
    <Illustration component={NotFoundSvg} {...props} />
);
export default NotFound;
